
import React, { useRef, useEffect, useState } from "react";

import './styles.css'


/*
 options: [
        { nombre:'tarea1.doc', filename:'345345fsdf.doc' },
        { nombre:'taread4 df.jpg', filename:'234234234.jpg' },
        { nombre:'foto.png', filename:'234234234.png' }, 
      ],

dissabled:dissabled 
 */
const ListFilePeq = ({ name, options, fileURL, 
                    onChange,  
                    disabled, ...props }) => {
    // 
    //const [label, setLabel] = useState(value);
    //const defaultChecked = checked ? checked : false;
    //const [isChecked, setIsChecked] = useState(defaultChecked);
    //const [isChecked, setIsChecked] = useState(defaultChecked);
    const click_func =(e)=>{
      console.log("click_func")
      //--- a cada click tenemos que hacer que cambie de valor
    
      //------ preparamos para enviar afuera
      e.target.name = name
      e.target.value = 'new_value'
      //console.log(e.target.value)
      onChange(e);
    }
    //--------------------------------
    const click_delete=(item)=>{
      console.log("click_delete")
      //----borramos un item
      //onDelete(item);
    }
    const click_ver=(item)=>{
      console.log("click_ver")
      //----borramos un item
      let fileURL1 = fileURL + item.filename;
      let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
      window.open(fileURL1,'',windowFeatures);
    }
    const click_down=(item)=>{
      console.log("click_down")
      //----borramos un item
      //onDelete(item);
    }
    //-----------------------------------
    return (
      <div>
        {
          //JSON.stringify(options)
        }
        <div className="box3">

          <ul className="list-group">
            {
              options.map((item, index) => (
                <li key={index} className="">
                  <div style={{ width: '80%' }}>
                    {item.nombre}
                  </div>
                  <span className="right-icon "  style={{ color: '#0d6efd'}}
                        onClick={()=>click_ver(item)}>
                    <i className=" fa fa-eye fa-lg"></i>
                  </span>
                  {/*
                  <span className="right-icon " onClick={()=>click_delete(item)}>
                    <i className=" fa fa-trash fa-lg"></i>
                  </span>*/}
                </li>
              ))
            }

          </ul>
        </div>


      </div>
    );
  }
  
  export default ListFilePeq;


  /*<NuCheckbox
      label=""
      name="chk_e1"
      value={this.state.form.chk_e1}
      onChange={ this.handleChangeForm }
    />*/



    /*
    <li>
          Item One
          <span className="badge">2</span>
        </li>
        <li>
          Item Two
          <span className="badge">10</span>
        </li>
        <li>
          Item Three
          <span className="badge">9</span>
        </li>
        <li>
          Item Four
          <span className="badge">0</span>
        </li>
         */